import { EOfferSpendByOfferView } from '../../enum'

// Create a union type of all possible values from the enum
type IOfferSpendByOfferViewLangKey = `${EOfferSpendByOfferView}`

export type IOfferSpendByOfferViewLang = {
	offer_spend_by_offer_view: Record<IOfferSpendByOfferViewLangKey, string>
}

const langEntries = Object.entries(EOfferSpendByOfferView).map(
	([key, value]) => [value, `offer_spend_by_offer_view.${value}`]
)

const langObj: Record<IOfferSpendByOfferViewLangKey, string> = Object.fromEntries(langEntries)

export const OFFER_SPEND_BY_OFFER_VIEW_LANG_KEY: IOfferSpendByOfferViewLang = {
	offer_spend_by_offer_view: langObj
}
